export const FOOTER_COLUMNS = [
  {
    title: "Adani Shantigram",
    links: [
      { label: "Adani Shantigram Overview", href: "/adani-shantigram" },
      { label: "Flats in Adani Shantigram", href: "/adani-shantigram-flats" },
      { label: "Adani Shantigram Price List", href: "/adani-shantigram-price" },
      { label: "2 BHK Flats in Shantigram", href: "/adani-shantigram-2-bhk" },
      { label: "3 BHK Flats in Shantigram", href: "/adani-shantigram-3-bhk" },
      { label: "4 BHK Flats in Shantigram", href: "/adani-shantigram-4-bhk" },
      { label: "5 BHK Homes in Shantigram", href: "/adani-shantigram-5-bhk" },
      { label: "Penthouses in Shantigram", href: "/adani-shantigram-penthouses" },
      { label: "Villas in Shantigram", href: "/adani-shantigram-villas" },
      { label: "Resale Flats in Shantigram", href: "/adani-shantigram-resale" },
      { label: "Flats for Rent in Shantigram", href: "/adani-shantigram-rent" },
      { label: "Ready to Move Flats", href: "/adani-shantigram-ready-to-move" },
    ],
  },
  {
    title: "Projects",
    links: [
      { label: "The Storeys", href: "/adani-shantigram/the-storeys" },
      { label: "The Storeys Infinity", href: "/adani-shantigram/the-storeys-infinity" },
      { label: "The Storeys Golf Coast", href: "/adani-shantigram/the-storeys-golf-coast" },
      { label: "Paarijat", href: "/adani-shantigram/paarijat" },
      { label: "La Marina", href: "/adani-shantigram/la-marina" },
      { label: "Water Lily", href: "/adani-shantigram/water-lily" },
      { label: "Aster NEO", href: "/adani-shantigram/aster-neo" },
      { label: "The North Park Villas", href: "/adani-shantigram/the-north-park" },
      { label: "The West Park", href: "/adani-shantigram/the-west-park" },
      { label: "Resale Properties", href: "/adani-shantigram/resale-properties" },
    ],
  },
  {
    title: "Services",
    links: [
      { label: "Ahmedabad Real Estate", href: "/ahmedabad-real-estate" },
      { label: "Luxury Real Estate Ahmedabad", href: "/luxury-real-estate-ahmedabad" },
      { label: "Luxury Properties Ahmedabad", href: "/luxury-properties-ahmedabad" },
      { label: "Residential Property Ahmedabad", href: "/residential-property-ahmedabad" },
      { label: "Commercial Property Ahmedabad", href: "/commercial-property-ahmedabad" },
      { label: "Real Estate Consultant Ahmedabad", href: "/real-estate-consultant-ahmedabad" },
      { label: "Property Consultant Ahmedabad", href: "/property-consultant-ahmedabad" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About VR Ahmedabad Realtors", href: "/about" },
      { label: "Contact Us", href: "/contact" },
      { label: "Property Insights & Guides", href: "/insights" },
      { label: "Shantigram Property Guide", href: "/insights/adani-shantigram-property-guide" },
      { label: "Luxury Areas of Ahmedabad", href: "/insights/best-luxury-residential-areas-in-ahmedabad" },
      { label: "Resale Buying Guide", href: "/insights/guide-to-buying-resale-property-in-ahmedabad" },
      { label: "GIFT City Investment Guide", href: "/insights/gift-city-property-investment-guide" },
    ],
  },
];
